<template>
    <div class="w-full col-span-1 mb-4 ">
        <div class="relative p-2 bg-white border border-gray-300 rounded-md">
            <svg
                class="absolute w-6 h-6 text-blue-600 left-2 top-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
            </svg>

            <p class="px-12 py-2 text-sm leading-relaxed ">
                {{ info[$route.name].description }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoMessage",
    data() {
        return {
            info: {
                installations_techniques: {
                    description:
                        "Unités fixes d'usage pouvant comprendre constructions, matériels ou pièces qui, mêmes séparables par nature, sont techniquement liés pour leur fonctionnement et que cette incorporation de caractère irréversible rend passible du même rythme d'amortissement"
                },
                materiels_et_outillage: {
                    description:
                        "Ensemble des équipements et machines, instruments (outils, machines, matrices ...) dont l’utilisation, concurremment avec un matériel, spécialise ce dernier dans un emploi déterminé "
                },
                moyens_de_transports_et_manutentions: {
                    description:
                        "Il comprend les véhicules et appareils servant au transport des personnes, des marchandises, des matières et des produits sous quelque mode que ce soit(par terre, par fer, par air ou par eau)"
                },
                mobilier_et_bureaux: {
                    description:
                        "Le mobilier comprend les meubles et objets tels que tables, chaises, utilisés par les services administratifs ou par d’autres services."
                },
                materiel_informatique: {
                    description:
                        "Comprend les unités centrales des ordinateurs, les terminaux, les imprimantes etc...à l'exclusion des logiciels non integrés au prix d'achat total."
                },
                i_t_m_o: {
                    description:
                        "Installations Techniques, matériel et outillage technique: il s'agit de toutes les installations, matériels et machines, ainsi que leurs agencements et aménagements, liés directement à l'activité de l'entreprise."
                }
            }
        };
    }
};
</script>

<style scoped></style>
